module.exports = __webpack_public_path__ + "static/media/SEO@2x.f3b78c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/SEO@2x.png
// module id = 81
// module chunks = 0